export const BASE_FILTER_OPTIONS_ACTION_TYPES = {
    SET_FILTERS_OPTIONS: 'base/filters/options/SET_FILTERS_OPTIONS',
    CLEAR_FILTERS_OPTIONS: 'base/filters/options/CLEAR_FILTERS_OPTIONS',
};
